<template>
    <div class="progress special-negative-margins" style="height: 5px;">
        <div role="progressbar"
            :class="this.progressBarClass"
            :aria-valuenow="this.progressBarValue==100 ? 95 : this.progressBarValue"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="'width: ' + (this.progressBarValue==100 ? 95 : this.progressBarValue) + '%'"></div>
    </div>
</template>

<script>

export default {
    name: 'ProgressBar',
    emits: ["update:application-settings"],
    components: {
    },
    props: {
        applicationSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        return {
        };
    },
    methods: {
        increaseProgressBarValue(amount = null) {
            let progressNow = this.applicationSettings.progressBar.valueNow ?? 0;
            let progressToAdd = amount ?? this.applicationSettings.progressBar.stepProgress;
            if( progressNow > 60 || (progressNow + progressToAdd >= 100) ) {
                progressToAdd = Math.trunc(Math.floor((100-progressNow)/3));
            }
            this.applicationSettings.progressBar.valueNow = progressNow + progressToAdd;
        },
    },
    computed: {
        progressBarValue() {
            return !!this.applicationSettings.progressBar.isFinalStep ?
                100 : this.applicationSettings.progressBar.valueNow;
        },
        progressBarClass() {
            let elementClass = '';
            elementClass += 'progress-bar progress-bar-striped progress-bar-animated ';
            // elementClass += (this.progressBarValue>=100 ? 'bg-success' : '');
            return elementClass;
        }
    },
    created() {
        // console.log('Component created');
    },
    mounted() {
        // console.log('Component mounted');
    },
    watch: {
        "applicationSettings.progressBar.step": {
            // immediate: true,
            handler(newValue) {
                this.increaseProgressBarValue();
            }
        },
    }
};
</script>

<style scoped>

.special-negative-margins {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
    margin-top: -1.5rem !important;
}

@media (min-width: 768px) {
    .special-negative-margins {
        margin-left: -3rem !important;
        margin-right: -3rem !important;
        //margin-top: -1.5rem !important;
    }
}
</style>
